import GlobalBreadcrumbsMixin from "../../Mixins/GlobalBreadcrumbsMixin";
import ComponentMixin from "../../Mixins/ComponentMixin";
import SetupStore from "@shared/components/Setup/SetupStore";

export default {
  mixins: [GlobalBreadcrumbsMixin, ComponentMixin],

  mounted () {
    this.setBreadcrumb(this.$t("common.merchantProfile"));
  },

  methods: {
    navigateToEditRoute (response) {
      this.$router.push({
        path: SetupStore.setupStages[1](response)
      });
    }
  }
};
